var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ps-btn ps-btn--sm ps-btn--white ps-btn--shadow",attrs:{"href":"#"},on:{"click":_vm.cancelJob}},[_vm._v(_vm._s(_vm.word.cancel))])}
var staticRenderFns = []

export { render, staticRenderFns }